import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import Availability from '../Basepage/parts/Availability';
import { PageMode } from '../Basepage/parts/Definitions';
import ProductCarousel from '../Basepage/parts/ProductCarousel';
import ImageContainer from './Parts/ImageContainer';
import SubTitle from './Parts/SubTitle';
import SozialShare from './Parts/SozialShare';
import DescriptionContainer from './Parts/DescriptionContainer';
import JSONLD_PD from './Parts/JSONLD_PD';
import FB_pixel from './Parts/FB_pixel';
import GoogleAnalytics from './Parts/GoogleAnalytics';
import WebgainsDetailsTag from './Parts/WebgainsDetailsTag';

import './index.scss';
import { replaceAllComplex } from '../../../../mol_function';
import VariantsManager from './Parts/VariantsManager';
import { getPODSnipped, getVorbestellenSnipped } from './overrides';
import MolLink from '../Basepage/parts/Menu/MolLink';

interface ProductInfoPageState extends BasePageState {}

interface ProductInfoPageModel {
  images: string[];
  imagesSmall: string[];
  productsDeliveryTime: number;
  domainPrefix: string;
  cutOff: any;
  isNewProduct: boolean;
  isShipingFree: boolean;
  isPackageSend: boolean;

  productPrice: string;
  productsId: number;

  products_quantity: number;
  products_quantity_order_max: number;

  productsDescription: string;

  hasProduct: boolean;
  securityToken: string;

  apd: ProductCarouselModel[];
  recent_products?: ProductCarouselModel[];

  title: string;
  categorie: string;
  link: string;

  attribute: [{ name: string; seperator: string | null; value: string }];

  reviews: ReviewDetails[];
  media: any;
  ean: string;
  release_date: string | null;
  pod_shipingTime: number | undefined;
}

export default class ProductInfoPage extends Basepage<
  ProductInfoPageState,
  ProductInfoPageModel
> {
  pageHeaderGetter(): string | null {
    let myLink = this.getCanonicalLink();

    let canonicalLink = '<link rel="canonical" href="' + myLink + '" />';

    let omgImage = '';
    for (
      let i = 0;
      this.body.images != null && i < this.body.images.length;
      i++
    )
      omgImage +=
        '<meta property="og:image" content="https://media.moluna.de/images/bilder/' +
        this.body.images[i] +
        '">';

    return canonicalLink + omgImage;
  }
  getCanonicalLink(): string | null {
    return this.body.link;
  }

  pageTitleGetter() {
    if (this.body.hasProduct)
      return (
        this.body.title +
        ' [' +
        this.body.productsId +
        '] - ' +
        this.body.productPrice
      );
    else {
      return '';
    }
  }

  getRightBreadCrumbParts(): JSX.Element {
    if (this.state.hasApiData) {
      return (
        <a
          className="artikel-bewerten"
          href={
            '/index.php?main_page=product_reviews_write&products_id=' +
            this.body.productsId +
            '&number_of_uploads=0'
          }
          title="Artikel bewerten"
        >
          Artikel bewerten
        </a>
      );
    } else return null;
  }
  getType(): string {
    return 'ProductInfoPage';
  }
  getBreadCrumb() {
    if (this.state.apiData)
      return (
        <React.Fragment>
          <MolLink
            href={
              this.state.renderingDomain +
              '/Kategorie/' +
              this.body.categorie +
              '/s/'
            }
            to={'/search_page/?fqZZZKategorie=' + this.body.categorie}
          >
            {this.body.categorie}
          </MolLink>
          <span>
            {replaceAllComplex(this.body.title, [
              { s: "\\'", r: "'" },
              { s: '\\"', r: '"' },
            ])}
          </span>
        </React.Fragment>
      );
    else return <div>Laden</div>;
  }
  initState(base: BasePageState): ProductInfoPageState {
    let dummy: any = this.props;

    let newState: ProductInfoPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(): string {
    let anyProps: any = this.props;

    return (
      this.state.apiBase +
      '/index.php?frame=api&main_page=product_info&products_id=' +
      anyProps.match.params.products_id
    );
  }
  childDidMount(): void {
    let anyProps: any = this.props;

    let apdUrl =
      this.state.apiBase +
      '/index.php?frame=api&main_page=product_info_apd&products_id=' +
      anyProps.match.params.products_id;

    fetch(apdUrl, {
      headers: {
        //'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        let tdata = data;
        let curentState = this.state.apiData;

        let oldApd = curentState.body.apd;
        let nedReload = false;

        if (JSON.stringify(oldApd) != JSON.stringify(data.body.apd)) {
          curentState.body.apd = data.body.apd;
          nedReload = true;
        }

        if (
          nedReload &&
          this.getType() == 'ProductInfoPage' &&
          this.state.hasApiData
        ) {
          this.setState({ apiData: curentState });
        }
      });
  }

  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}

  renderChild() {
    let productsDeliveryDate: Date | undefined = undefined;
    if (this.body.release_date != null) {
      productsDeliveryDate = new Date(Date.parse(this.body.release_date));
    }

    return (
      <div id="productInfo">
        {this.body.hasProduct ? (
          <form
            action={
              this.state.renderingDomain +
              '/index.php?main_page=product_info&products_id=' +
              this.body.productsId +
              '&number_of_uploads=0&action=add_product'
            }
            method="POST"
            enctype="application/x-www-form-urlencoded"
          >
            <input
              type="hidden"
              name="securityToken"
              value={this.body.securityToken}
            />
            <ImageContainer
              hasProduct={this.body.hasProduct}
              images={this.body.images}
              imagesSmall={this.body.imagesSmall}
              domainPrefix={this.state.renderingDomain}
              isNewProduct={this.body.isNewProduct}
              isShipingFree={this.body.isShipingFree}
              isPackageSend={this.body.isPackageSend}
              hasLeseprobe={
                this.body.media != undefined &&
                Object.keys(this.body.media).length > 0
              }
              title={this.body.title}
              height={this.state.mode != PageMode.Mobile ? 450 : 200}
              showDots={this.state.mode != PageMode.Mobile}
            ></ImageContainer>
            <div id="p-right">
              <div className="p-right_in">
                {this.state.mode != PageMode.Mobile ? (
                  <div id="categoryIcon" className="categoryIcon">
                    <a
                      href={
                        this.state.renderingDomain +
                        '/Kategorie/' +
                        this.body.categorie +
                        '/s/'
                      }
                    >
                      {this.body.categorie}
                    </a>
                  </div>
                ) : null}

                <h1 id="productName" className="productGeneral">
                  <SubTitle
                    category={this.body.categorie}
                    attribute={this.body.attribute}
                    domainPrefix={this.state.renderingDomain}
                  ></SubTitle>
                </h1>
                {this.body.productsDeliveryTime == 994 ? getPODSnipped() : null}

                {this.body.productsDeliveryTime == 998
                  ? getVorbestellenSnipped()
                  : null}

                <h2 id="productPrices" className="productGeneral">
                  {this.body.productPrice}
                </h2>
                <div className="taxAddon">
                  inkl. MwSt. ·{' '}
                  {this.body.isShipingFree ? (
                    'Portofrei'
                  ) : (
                    <a
                      href={
                        this.state.renderingDomain +
                        '/index.php?main_page=shippinginfo'
                      }
                      target="_blank"
                    >
                      zzgl. Versand
                    </a>
                  )}
                </div>

                <div id="cartAdd">
                  <Availability
                    productsDeliveryTime={this.body.productsDeliveryTime}
                    cutOff={this.body.cutOff}
                    domainPrefix={this.state.renderingDomain}
                    productsDeliveryDate={productsDeliveryDate}
                    productsDeliveryTimeOverride={this.body.pod_shipingTime}
                  />
                  {/*TODO: Wrap in cart */}
                  <div id="wrap_incart"></div>
                </div>
              </div>
              <div id="incart_button">
                <input
                  type="hidden"
                  name="products_id"
                  value={this.body.productsId}
                ></input>
                {this.body.productsDeliveryTime < 999 && (
                  <React.Fragment>
                    <div className="qty_button">
                      {this.state.mode != PageMode.Mobile ? (
                        <span className="qty_txt">Menge: </span>
                      ) : null}
                      <input
                        className="cart_quantity"
                        type="text"
                        name="cart_quantity"
                        defaultValue="1"
                        maxLength={3}
                        size={3}
                      />
                    </div>
                    <div>
                      <a
                        title={
                          this.body.title +
                          ' ' +
                          this.body.categorie +
                          ' in den Warenkorb'
                        }
                        rel="nofollow"
                      >
                        <input
                          className="button_in_cart"
                          type="submit"
                          value="in den Warenkorb"
                        />
                      </a>

                      <a
                        href={
                          this.state.renderingDomain +
                          '/index.php?main_page=product_info&products_id=' +
                          this.body.productsId +
                          '&quick_checkout=klarna'
                        }
                        title={
                          this.body.title +
                          ' ' +
                          this.body.categorie +
                          ' jetzt kaufen'
                        }
                        rel="nofollow"
                      >
                        <input
                          className="button_in_checkout"
                          type="submit"
                          value="zur Kasse gehen"
                          onClick={(e) => {
                            e.preventDefault();
                            e.target.parentElement.click();
                          }}
                        />
                      </a>
                      <a
                        href={
                          this.state.renderingDomain +
                          '/index.php?main_page=product_info&products_id=' +
                          this.body.productsId +
                          '&quick_checkout=paypal'
                        }
                        title={
                          this.body.title +
                          ' ' +
                          this.body.categorie +
                          ' mit PayPal bezahlen'
                        }
                        rel="nofollow"
                      >
                        <input
                          className="button_in_paypal"
                          type="submit"
                          value="Checkout"
                          onClick={(e) => {
                            e.preventDefault();
                            e.target.parentElement.click();
                          }}
                        />
                      </a>

                      <div style={{ width: '100%' }}>
                        <SozialShare
                          productsId={this.body.productsId}
                          domainPrefix={this.state.renderingDomain}
                          canonicalLink={this.body.link}
                        ></SozialShare>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
              <VariantsManager
                variants={this.body.variants}
                thisProductId={this.body.productsId}
                productTittle={this.body.title}
              />
            </div>

            <br className="clearBoth"></br>
            <div id="cart">
              <DescriptionContainer
                attribute={this.body.attribute}
                productsId={this.body.productsId}
                productsDescription={this.body.productsDescription}
                domainPrefix={this.state.renderingDomain}
                category={this.body.categorie}
                title={this.body.title}
                reviews={this.body.reviews}
                media={this.body.media}
                ean={this.body.ean}
              />
            </div>
            <br className="clearBoth"></br>
            {this.body.recent_products != null &&
            this.body.recent_products.length > 0 ? (
              <div>
                <h3 className="border" style={{ marginBottom: '0px' }}>
                  Zuletzt angesehen
                </h3>
                <ProductCarousel
                  items={this.body.recent_products}
                ></ProductCarousel>
              </div>
            ) : null}
            {this.body.apd != null && this.body.apd.length > 0 ? (
              <div>
                <h3 className="border" style={{ marginBottom: '0px' }}>
                  Ähnliche Artikel
                </h3>
                <ProductCarousel items={this.body.apd}></ProductCarousel>
              </div>
            ) : null}
            <div id="p-more-mobile">
              <SozialShare
                productsId={this.body.productsId}
                domainPrefix={this.state.renderingDomain}
                canonicalLink={this.body.link}
              ></SozialShare>
            </div>

            <JSONLD_PD body={this.body}></JSONLD_PD>
            <FB_pixel body={this.body}></FB_pixel>
            <GoogleAnalytics></GoogleAnalytics>
            <WebgainsDetailsTag
              isBook={this.body.categorie == 'Buch'}
              productID={this.body.productsId}
              productPrice={this.body.productPrice}
              name={this.body.title}
            ></WebgainsDetailsTag>
          </form>
        ) : (
          <div className="centerColumn" id="productInfoNoProduct">
            <div id="productInfoNoProductMainContent" className="content">
              Entschuldigen Sie bitte, aber der gewünschte Artikel konnte nicht
              gefunden werden.
            </div>
            <br />
            <br />

            <div className="buttonRow back">
              <a
                href={this.state.renderingDomain + 'index.php?main_page=index'}
              >
                <span
                  className="cssButton normal_button button  button_continue"
                  onMouseOver={(e) => {
                    let target = e.target;
                    target.className =
                      'cssButtonHover normal_button button  button_continue button_continueHover';
                  }}
                  onMouseOut={(e) => {
                    let target = e.target;
                    target.className =
                      'cssButton normal_button button  button_continue';
                  }}
                >
                  &nbsp;Fortfahren&nbsp;
                </span>
              </a>
            </div>
          </div>
        )}
      </div>
    );
  }
}
